import React, { useCallback, useEffect, useRef } from 'react';
import s from './chat.module.scss';
import classNames from 'classnames';
import { useMedia } from 'use-media';
import { useLocation } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import { useProfile } from '@shared/api/useProfile';
import { useChatStore, wsBuilder } from '@entities/messanger';
import { useWebSocketContext } from '@shared/context/WebSocketProvider';
import { ChatList } from '@features/messanger/chat-list';
import { ChatSearch, useChatSearch } from '@features/messanger/chat-search';
import { ChatWindow } from '@widgets/messanger/ui/chat-window';

export const Chat = ({ className }) => {
  const isMobile = useMedia({ maxWidth: '768px' });
  const { state } = useLocation();
  const idUserInChat = state?.id_user_in_chat;

  const { data: profile } = useProfile();
  const { sendJsonMessage } = useWebSocketContext();

  const { selectedChat, selectChat, chats } = useChatStore(
    useShallow((state) => ({
      selectedChat: state.selectedChat,
      selectChat: state.selectChat,
      chats: state.chats,
    }))
  );

  const { query, setQuery, filteredChats } = useChatSearch(chats);

  const onRead = useCallback(
    (id, chat_id) => {
      sendJsonMessage(wsBuilder.read(id, chat_id));
    },
    [sendJsonMessage]
  );

  const processedRef = useRef(false);

  useEffect(() => {
    if (!idUserInChat || processedRef.current) return;
    const chat = chats?.find((el) => el.participants[0]?.id === idUserInChat);
    if (chat) {
      selectChat(chat);
      processedRef.current = true;
      window.history.replaceState({}, '');
    }
  }, [idUserInChat, chats, selectChat]);

  return (
    <div className={classNames(className, s.card)}>
      {(!selectedChat || !isMobile) && (
        <div className={s.chatSidebar}>
          <ChatSearch
            value={query}
            onChange={setQuery}
            className={s.search}
            disabled={chats.length === 0}
          />
          <ChatList chats={filteredChats} query={query} />
        </div>
      )}
      {(!isMobile || selectedChat) && (
        <ChatWindow isMobile={isMobile} profile={profile} onRead={onRead} />
      )}
    </div>
  );
};
